// extracted by mini-css-extract-plugin
export default {"container":"components-Cart-PurchaseConditionsIcons-styles-module__container--Dw_Y8","infoContainer":"components-Cart-PurchaseConditionsIcons-styles-module__infoContainer--MiKmb"};